import { render } from "./UploadShipmovement.vue?vue&type=template&id=daf1606e&scoped=true"
import script from "./UploadShipmovement.vue?vue&type=script&lang=js"
export * from "./UploadShipmovement.vue?vue&type=script&lang=js"

import "./UploadShipmovement.vue?vue&type=style&index=0&id=daf1606e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf1606e"]])

export default __exports__